export default "__VITE_ASSET__DHeUqwLV__"